import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import TrademarkList from "@/components/lists/trademark.vue"
  import TrademarkToolbar from "@/components/toolbars/trademark.vue"
  import {nextTick, onBeforeMount, PropType, ref} from "vue"
  import {
    Trademark,
    TrademarkInput,
    TrademarkResponse
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import Paginator from "@/components/paginator.vue"
  import {Trademark as TrademarkClient} from "@/endpoints/rutsolve/gql/resolvers/trademark"
  import {TrademarkSelector as Storage} from "@/storage/trademark_selector"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'trademark',
  props: {
    "value": {
    default: null,
    required: false,
    type: Object as PropType<Trademark>
  },
    "valueModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels([
    "select",
  ], ["update:value"]),
  setup(__props, { emit: __emit }) {

  const value = _useModel(__props, "value")

  const emits = __emit

  const error = ref<Error>(null)
  const trademarkClient = new TrademarkClient()
  const trademarkResponse = ref<TrademarkResponse>(null)
  const trademarkInput = ref<TrademarkInput>(null)
  const selectedIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  function update() {
    Storage.writeTrademarkInput(trademarkInput.value)
    read()
  }

  async function select() {
    const selectedTrademark = trademarkResponse.value.records[selectedIndex.value]
    value.value = selectedTrademark
    Storage.writeSelectedTrademarkID(selectedTrademark.id)
    await nextTick()
    emits("select")
  }

  function reset() {
    Storage.deleteTrademarkInput()
    Storage.deleteSelectedTrademarkID()
    selectedIndex.value = null
    value.value = null
    read()
  }

  async function read() {
    try {
      const storedTrademarkInput = Storage.readTrademarkInput()
      trademarkInput.value = structuredClone(storedTrademarkInput)
      trademarkResponse.value = await trademarkClient.selector(storedTrademarkInput)
      if (!trademarkResponse.value || !trademarkResponse.value.records) {
        return
      }
      const storedSelectedTrademarkID = Storage.readSelectedTrademarkID()
      for (const [index, trademark] of trademarkResponse.value.records.entries()) {
        if (trademark.id == storedSelectedTrademarkID) {
          selectedIndex.value = index
          value.value = trademark
          break
        }
      }
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(TrademarkToolbar, {
        value: trademarkInput.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((trademarkInput).value = $event)),
        onUpdate: _cache[1] || (_cache[1] = ($event: any) => (update())),
        onReset: _cache[2] || (_cache[2] = ($event: any) => (reset()))
      }, null, 8, ["value"]),
      (trademarkResponse.value)
        ? (_openBlock(), _createBlock(TrademarkList, {
            key: 0,
            selectedIndex: selectedIndex.value,
            "onUpdate:selectedIndex": _cache[3] || (_cache[3] = ($event: any) => ((selectedIndex).value = $event)),
            items: trademarkResponse.value.records,
            onSelect: _cache[4] || (_cache[4] = ($event: any) => (select()))
          }, null, 8, ["selectedIndex", "items"]))
        : _createCommentVNode("", true),
      (trademarkResponse.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 1,
            currentPage: trademarkInput.value.plot.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((trademarkInput.value.plot.page) = $event)),
            itemTotal: trademarkResponse.value.recordsTotal,
            pageItems: trademarkInput.value.plot.items,
            onUpdate: _cache[6] || (_cache[6] = ($event: any) => (update()))
          }, null, 8, ["currentPage", "itemTotal", "pageItems"]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 2,
            error: error.value,
            "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})